module.exports = __webpack_public_path__ + "img/send_email.b428c1d2.gif";